import DraggableTable from './container/index';

export default DraggableTable;



// WEBPACK FOOTER //
// ./src/components/ui/DraggableTable/index.jsx